"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSearchHeaderResponseSchema = exports.UniversalSearchHeaderRequestBodySchema = exports.UniversalSearchRequestBodySchema = exports.UniversalSearchTabInfoSchema = exports.UniversalSearchTabItemInfoSchema = exports.SORT_TYPE = exports.CATEGORY_TYPE = void 0;
var zod_1 = require("zod");
var sort_info_1 = require("../common/sort-info");
var quick_filter_1 = require("../common/quick-filter");
var global_filter_1 = require("../common/global-filter");
exports.CATEGORY_TYPE = {
    LOCAL_ACCOMMODATION: 'LOCAL_ACCOMMODATION',
    LOCAL_LEISURE: 'LOCAL_LEISURE',
    GLOBAL_ACCOMMODATION: 'GLOBAL_ACCOMMODATION',
    ENTERTAINMENT: 'ENTERTAINMENT',
    FLIGHT: 'FLIGHT',
    NOL_TICKET: 'NOL_TICKET',
    GLOBAL_TNA: 'GLOBAL_TNA', // 해외투어티켓
};
exports.SORT_TYPE = {
    RECOMMEND: 'RECOMMEND',
    PRICE_ASC: 'PRICE_ASC',
    PRICE_DESC: 'PRICE_DESC',
    REVIEW_SCORE_DESC: 'REVIEW_SCORE_DESC',
    REVIEW_COUNT_DESC: 'REVIEW_COUNT_DESC',
    FAVORITE_COUNT_DESC: 'FAVORITE_COUNT_DESC',
    /* 공연/전시 */
    SOLD_COUNT_DESC: 'SOLD_COUNT_DESC',
    END_DATE_ASC: 'END_DATE_ASC',
    REGISTERED_DATE_DESC: 'REGISTERED_DATE_DESC',
};
exports.UniversalSearchTabItemInfoSchema = zod_1.z.object({
    key: zod_1.z.nativeEnum(exports.CATEGORY_TYPE),
    title: zod_1.z.string(),
    hasMapView: zod_1.z.boolean(),
    selected: zod_1.z.boolean(),
    isNew: zod_1.z.boolean().nullish(),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.UniversalSearchTabInfoSchema = zod_1.z.object({
    items: zod_1.z.array(exports.UniversalSearchTabItemInfoSchema).nullish(),
});
exports.UniversalSearchRequestBodySchema = zod_1.z.object({
    filters: zod_1.z.array(zod_1.z.record(zod_1.z.string(), zod_1.z.any())).nullish(),
    keyword: zod_1.z.string().nullish(),
    category: zod_1.z.nativeEnum(exports.CATEGORY_TYPE).nullish(),
    page: zod_1.z.number().nullish(),
    cursor: zod_1.z.string().nullish(),
    sort: zod_1.z.nativeEnum(exports.SORT_TYPE),
    userLocation: zod_1.z.object({
        latitude: zod_1.z.number().nullish(),
        longitude: zod_1.z.number().nullish(),
        locationType: zod_1.z.enum(['DEFAULT', 'GPS', 'MANUAL']).nullish(),
        locationTime: zod_1.z.number().nullish(),
    }),
    localAccommodation: zod_1.z.object({
        checkInDate: zod_1.z.string().nullish(),
        checkOutDate: zod_1.z.string().nullish(),
        capacityAdults: zod_1.z.number().nullish(),
        childrenAges: zod_1.z.array(zod_1.z.number()).nullish(),
    }),
    globalAccommodation: zod_1.z.object({
        checkInDate: zod_1.z.string().nullish(),
        checkOutDate: zod_1.z.string().nullish(),
        rooms: zod_1.z
            .array(zod_1.z.object({
            capacityAdults: zod_1.z.number().nullish(),
            childrenAges: zod_1.z.array(zod_1.z.number()).nullish(),
        }))
            .nullish(),
    }),
});
exports.UniversalSearchHeaderRequestBodySchema = zod_1.z
    .object(__assign(__assign({}, exports.UniversalSearchRequestBodySchema.shape), { page: zod_1.z.undefined().optional(), entryPoint: zod_1.z.string().optional() }))
    .omit({ page: true }); // page 속성 제거
/**
 * LIST API - 통합 SRP 헤더 영역 조회 응답
 * @see {@link https://fe-api-doc.dev.yanolja.in/?api=cx-list-api#tag/universal-search-v1/paths/~1universal-search~1v1~1header/post}
 */
exports.UniversalSearchHeaderResponseSchema = zod_1.z.object({
    tabInfo: exports.UniversalSearchTabInfoSchema.nullish(),
    sortInfo: sort_info_1.SortInfoSchema.nullish(),
    hasSelectedFilter: zod_1.z.boolean().nullish(),
    quickFilter: quick_filter_1.QuickFilterSchema.nullish(),
    globalFilter: global_filter_1.GlobalFilterSchema.nullish(),
    /** 리스트 영역 조회를 위한 request 정보 */
    request: exports.UniversalSearchHeaderRequestBodySchema.nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
